export const chromeExtensionDownloadLink =
  'https://chrome.google.com/webstore/detail/save-cars-across-many-sit/ddcabilfaldblnbjjdakdhdkggmncplh?source=fhub';
